import { render, staticRenderFns } from "./InformationLetter.vue?vue&type=template&id=67388727&scoped=true&"
import script from "./InformationLetter.vue?vue&type=script&lang=js&"
export * from "./InformationLetter.vue?vue&type=script&lang=js&"
import style0 from "./InformationLetter.vue?vue&type=style&index=0&id=67388727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67388727",
  null
  
)

export default component.exports